import { render, staticRenderFns } from "./Installers.vue?vue&type=template&id=c4e537b0&scoped=true&"
import script from "./Installers.vue?vue&type=script&lang=js&"
export * from "./Installers.vue?vue&type=script&lang=js&"
import style0 from "./Installers.vue?vue&type=style&index=0&id=c4e537b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4e537b0",
  null
  
)

export default component.exports